// extracted by mini-css-extract-plugin
export default {"btn1":"error_btn1__+Z+XI","status":"error_status__kahOL","errorMessage":"error_errorMessage__duO9t","pageContainer":"error_pageContainer__by+d9","pageRow":"error_pageRow__w2tPf"};